import { css } from '@emotion/react';

export const container = css({
  position: 'relative',
  height: '465px',
  overflow: 'hidden'
});

export const scrollContainer = css({
  position: 'absolute',
  display: 'flex',
  flexDirection: 'row',
  flexShrink: 1,
  flexGrow: 1,
  width: 'infinite',
  height: 360,
  transition: '.5s',
  willChange: 'transform'
});
